import { logout } from './auth';

export const onDataErrorOccurred = async (e) => {
  if (e.xhr.status === 401) {
    await logout();
  }
};
